var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mave-analytics"},[_c('MavePlatforms',{attrs:{"group":_vm.group}}),_c('MaveDevices',{attrs:{"group":_vm.group}}),_c('MaveGeo',{attrs:{"group":_vm.group}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }